import { Cpu, Droplets, Factory, HardHat, Layers, TreePine } from "lucide-react";

export const CATEGORIES = [
  {
    id: "rescon", name: "RESCON (Residuos de la Construcción y Demolición)", short: "RESCON", items: "Hormigón, ladrillo, despuntes de perfiles y barras de acero", icon: HardHat, image: "/img/rescon.jpg",
    uses: [
      { t: "Chancado / Trituración Secundaria", d: "Los escombros de hormigón y ladrillo se trituran mecánicamente para producir áridos reciclados (grava, gravilla, estabilizados) utilizados en bases y subbases de caminos o rellenos estructurales." },
      { t: "Remanufactura y Reciclaje Directo", d: "Despuntes de perfiles metálicos y barras de acero se envían a fundición directa; mermas de madera se transforman en aglomerados o biomasa." },
    ],
    industries: [
      { t: "Empresas Constructoras y Obras Civiles", d: "Demandan áridos reciclados de bajo costo para nivelación de terrenos, pavimentación vial y rellenos de zanjas." },
      { t: "Plantas de Premezclado / Hormigoneras", d: "Utilizan áridos reciclados clasificados para formulaciones de hormigones no estructurales o prefabricados." },
      { t: "Fundiciones de Acero", d: "Compran retazos metálicos de enfierradura como chatarra pesada de carga." },
    ],
  },
  {
    id: "polimeros", name: "Polímeros Industriales y Plásticos de Grado Técnico", short: "Polímeros", items: "HDPE, PP, ABS, LDPE", icon: Layers, image: "/img/polimeros.jpg",
    uses: [
      { t: "Molienda y Peletizado (Extrusión / Inyección)", d: "Al ser residuos de composición homogénea y limpia (sin contaminación domiciliaria), se trituran en escamas (flakes) y se funden en pellets de resina reciclada." },
      { t: "Upcycling / Reutilización Directa", d: "Tambores y bins agrícolas lavados se reacondicionan mecánicamente para uso logístico secundario sin pasar por fundición." },
    ],
    industries: [
      { t: "Industria Plástica y de Matricería", d: "Compran pellets reciclados de HDPE, PP o ABS para abaratar hasta un 40% sus costos de materia prima en la fabricación de tubos, baldes, pallets plásticos, tuberías de riego o componentes automotrices." },
      { t: "Sector Agrícola y Acuícola", d: "Demandan tuberías y contenedores plásticos reciclados de alta resistencia para transporte de fluidos y biomasa." },
      { t: "Empresas de Embalaje / Logística", d: "Compran pellet de Film Stretch (LDPE) para fabricar nuevas bolsas industriales o láminas de protección." },
    ],
  },
  {
    id: "metales", name: "Scrap Metálico y Piezas Mecánicas", short: "Metales", items: "Cobre, Bronce, Aluminio, Acero Inoxidable", icon: Factory, image: "/img/metal.jpg",
    uses: [
      { t: "Reutilización Directa (Repuestos / Remanufactura)", d: "Componentes, válvulas, motores o bombas dados de baja por cambio de estándar son reacondicionados para volver al mercado técnico." },
      { t: "Fundición Específica (Refinación)", d: "Virutas CNC y despuntes de aleaciones puras (como acero inoxidable grado 304/316 o aluminio estructural) alimentan hornos de fundición para lingotes." },
    ],
    industries: [
      { t: "Fundiciones y Acerías", d: "Principales compradores de chatarra técnica no ferrosa y de acero inoxidable para su proceso de fusión." },
      { t: "Talleres Metalmecánicos y Maestranzas", d: "Compran perfiles, tubos y piezas mecánicas usadas de alta calidad para fabricación de estructuras, rejas o maquinaria a medida." },
      { t: "Sector Automotriz y Maquinaria Pesada", d: "Compran repuestos y componentes reacondicionados para mantención de flotas a menor costo." },
    ],
  },
  {
    id: "aceites", name: "Residuos Orgánicos Industriales y Aceites", short: "Orgánicos y Aceites", items: "ALU / AVU, mermas orgánicas y lodos", icon: Droplets, image: "/img/aceites.jpg",
    uses: [
      { t: "Aceites Lubricantes Usados (ALU)", d: "Se someten a procesos de re-refinado para recuperar bases lubricantes puras o se tratan como combustible secundario en hornos industriales." },
      { t: "Aceites Vegetales Usados (AVU)", d: "Se filtran y procesan químicamente (transesterificación) para la producción de Biodiésel." },
      { t: "Mermas Orgánicas y Lodos", d: "Compostaje industrial, digestión anaeróbica para generación de Biogás (energía térmica/eléctrica) y biofertilizantes (digestato)." },
    ],
    industries: [
      { t: "Industria de Biocombustibles y Refinerías", d: "Compran AVU para la fabricación de biodiésel e hidrotratamiento de combustibles limpios." },
      { t: "Cementeras e Industria Pesada", d: "Utilizan ALU tratado como combustible de alto poder calorífico en hornos rotatorios." },
      { t: "Sector Agrícola y Ganadero", d: "Demanda compost y digestatos orgánicos para enriquecimiento de suelos agrícolas." },
    ],
  },
  {
    id: "madera", name: "Madera y Biomasa Industrial", short: "Madera", items: "Pallets, despuntes, vigas", icon: TreePine, image: "/img/madera.jpg",
    uses: [
      { t: "Reparación y Remanufactura de Pallets", d: "Pallets dañados se desarman para recuperar tablas y ensamblar nuevos pallets estándar." },
      { t: "Chip / Astillado", d: "La madera sin tratamiento se chipea para fabricación de tableros aglomerados o como insumo energético (Pellets / Biomasa)." },
      { t: "Carpintería y Mueblería de Diseño", d: "Vigas y pino de buen formato son aprovechados directamente por artesanos y constructores de mobiliario." },
    ],
    industries: [
      { t: "Empresas de Logística y Centros de Distribución", d: "Compran pallets reacondicionados o reparados a fracción del precio nuevo." },
      { t: "Plantas de Biomasa y Calderas Industriales", d: "Consumen astillas o pellets de madera para generación de vapor y energía térmica." },
      { t: "Fabricantes de Tableros (MDF / Aglomerados)", d: "Utilizan chips de madera secundaria como fibra base." },
    ],
  },
  {
    id: "raee", name: "Residuos Eléctricos, Electrónicos y Baterías", short: "RAEE y Baterías", items: "Tarjetas electrónicas, cables, transformadores, plomo-ácido, litio", icon: Cpu, image: "/img/raee.jpg",
    uses: [
      { t: "Minería Urbana / Reciclaje Químico", d: "Despiece de tarjetas electrónicas, transformadores y cables para la recuperación de metales preciosos (cobre, oro, plata) y tierras raras." },
      { t: "Recuperación de Plomo y Litio", d: "Desensamble de baterías industriales de plomo-ácido y litio para neutralizar ácido y recuperar metal inerte." },
    ],
    industries: [
      { t: "Refinerías de Metales y Exportadores de RAEE", d: "Compran circuitos y tarjetas electrónicas para su procesamiento en plantas especializadas de fundición y minería urbana." },
      { t: "Fabricantes de Baterías", d: "Utilizan el plomo y compuestos reciclados como insumo primario en la fabricación de nuevas baterías industriales." },
      { t: "Técnicos y Mantenimiento Industrial", d: "Recuperan componentes eléctricos (contactores, relés, motores) en buen estado para repuestos." },
    ],
  },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

export const MODES = [
  { id: "subasta", label: "Subasta en vivo", filter: "Subasta", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  { id: "venta", label: "Venta Fija", filter: "Venta", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  { id: "donacion", label: "Gratis por Retiro", filter: "Donación", cls: "bg-indigo-500/10 text-indigo-700 border-indigo-500/30" },
];

export const MODE_MAP = Object.fromEntries(MODES.map((m) => [m.id, m]));

export const REGIONS = {
  "Región de Arica y Parinacota": ["Arica", "Putre"],
  "Región de Tarapacá": ["Iquique", "Alto Hospicio", "Pozo Almonte"],
  "Región de Antofagasta": ["Antofagasta", "Calama", "Mejillones", "Tocopilla"],
  "Región de Atacama": ["Copiapó", "Vallenar", "Caldera"],
  "Región de Coquimbo": ["La Serena", "Coquimbo", "Ovalle"],
  "Región de Valparaíso": ["Valparaíso", "Viña del Mar", "Quilpué", "San Antonio", "Los Andes"],
  "Región Metropolitana": ["Santiago", "Quilicura", "Pudahuel", "Maipú", "San Bernardo", "Lampa", "Renca", "Puente Alto"],
  "Región de O'Higgins": ["Rancagua", "San Fernando", "Machalí"],
  "Región del Maule": ["Talca", "Curicó", "Linares"],
  "Región de Ñuble": ["Chillán", "San Carlos"],
  "Región del Biobío": ["Concepción", "Talcahuano", "Coronel", "Los Ángeles"],
  "Región de La Araucanía": ["Temuco", "Padre Las Casas", "Villarrica"],
  "Región de Los Ríos": ["Valdivia", "La Unión"],
  "Región de Los Lagos": ["Puerto Montt", "Osorno", "Castro"],
  "Región de Aysén": ["Coyhaique", "Puerto Aysén"],
  "Región de Magallanes": ["Punta Arenas", "Puerto Natales"],
};

// Factores referenciales estimados (t CO2e evitadas por t valorizada; CLP por t)
export const FACTORS = [
  { id: "aridos", label: "Hormigón / áridos (RESCON)", category: "rescon", co2: 0.02, landfill: 18000, value: 5000 },
  { id: "aluminio", label: "Aluminio", category: "metales", co2: 9.1, landfill: 32000, value: 850000 },
  { id: "cobre", label: "Cobre", category: "metales", co2: 3.8, landfill: 32000, value: 6500000 },
  { id: "inox", label: "Acero Inox 304/316", category: "metales", co2: 1.6, landfill: 32000, value: 900000 },
  { id: "hdpe", label: "HDPE", category: "polimeros", co2: 1.8, landfill: 32000, value: 350000 },
  { id: "pp", label: "PP", category: "polimeros", co2: 1.6, landfill: 32000, value: 320000 },
  { id: "abs", label: "ABS", category: "polimeros", co2: 2.2, landfill: 32000, value: 400000 },
  { id: "ldpe", label: "Film Stretch LDPE", category: "polimeros", co2: 1.7, landfill: 32000, value: 220000 },
  { id: "alu", label: "Aceite lubricante usado (ALU)", category: "aceites", co2: 2.6, landfill: 190000, value: 150000 },
  { id: "avu", label: "Aceite vegetal usado (AVU)", category: "aceites", co2: 2.5, landfill: 120000, value: 350000 },
  { id: "madera", label: "Madera / Pallets", category: "madera", co2: 0.9, landfill: 28000, value: 40000 },
  { id: "raee", label: "RAEE / Tarjetas electrónicas", category: "raee", co2: 1.4, landfill: 160000, value: 1500000 },
  { id: "plomo", label: "Baterías plomo-ácido", category: "raee", co2: 1.1, landfill: 210000, value: 600000 },
];

export const CATEGORY_CO2 = { rescon: 0.02, metales: 3.5, polimeros: 1.8, aceites: 2.6, madera: 0.9, raee: 1.3 };

export const calcImpact = (factor, tons) => {
  const t = Math.max(0, Number(tons) || 0);
  return {
    co2: t * factor.co2,
    landfill: t * factor.landfill,
    value: t * factor.value,
    trees: Math.round((t * factor.co2 * 1000) / 22),
  };
};

// Lista Europea de Residuos (LER) por familia: [código, descripción, peligroso]
export const LER = {
  metales: [
    ["12 01 01", "Limaduras y virutas de metales férreos", false],
    ["12 01 03", "Limaduras y virutas de metales no férreos", false],
    ["17 04 01", "Cobre, bronce, latón", false],
    ["17 04 02", "Aluminio", false],
    ["17 04 05", "Hierro y acero", false],
    ["16 01 17", "Metales férreos (Vehículos fuera de uso / Repuestos)", false],
  ],
  polimeros: [
    ["07 02 13", "Residuos de plástico (Fábricas de polímeros / Mermas de inyección)", false],
    ["15 01 02", "Envases de plástico (Film stretch, bidones, garrafas limpias)", false],
    ["16 01 19", "Plásticos (Componentes automotrices o carcasas de equipos)", false],
    ["17 02 03", "Plástico (Perfiles de PVC, tuberías plásticas de construcción/acuicultura)", false],
  ],
  aceites: [
    ["13 01 10*", "Aceites hidráulicos clorados", true],
    ["13 02 05*", "Aceites de motor, de transmisión y lubricantes minerales", true],
    ["20 01 25", "Aceites y grasas comestibles (AVU / HORECA)", false],
    ["02 03 04", "Residuos aptos para consumo o transformación (Orgánicos de la industria alimentaria)", false],
  ],
  madera: [
    ["03 01 01", "Desperdicios de corte y descortezado de madera", false],
    ["03 01 05", "Serrín, virutas, recortes, madera, tableros y chapa", false],
    ["15 01 03", "Envases de madera (Pallets estándar y especiales)", false],
    ["17 02 01", "Madera en demolición y construcción", false],
  ],
  raee: [
    ["16 01 21*", "Componentes peligrosos distintos de los especificados en los códigos 16 01 07 a 16 01 11 o 16 01 13 y 16 01 14", true],
    ["16 02 14", "Equipos eléctricos y electrónicos desechados distintos de los especificados en los códigos 16 02 09 a 16 02 13", false],
    ["16 06 01*", "Baterías de plomo", true],
    ["16 06 05", "Otras baterías y acumuladores (Litio / Secas)", false],
    ["17 04 11", "Cables distintos de los especificados en el código 17 04 10", false],
  ],
  rescon: [
    ["17 01 01", "Hormigón (Concreto)", false],
    ["17 01 02", "Ladrillos", false],
    ["17 01 07", "Mezclas de hormigón, ladrillos, tejas y materiales cerámicos distintos de los especificados en el código 17 01 06", false],
    ["17 05 04", "Tierra y piedras distintas de las especificadas en el código 17 05 03", false],
  ],
};

export const PHYSICAL_STATES = ["Sólido", "Líquido", "Semisólido", "Polvo"];

// Datos de generador para el MVP (editables en el formulario)
export const MVP_GENERATOR = { razon_social: "Empresa Metales Varas", rut: "78380668-6", vu_code: "1780" };
